import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/authSlice";
import businessReducer from "./business/businessSlice";
import itemReducer from "./item/itemSlice";
import partyReducer from "./party/partySlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    business: businessReducer,
    items: itemReducer,
    party: partyReducer,
  },
});

export default store;
